<script setup>

import ProfessionalInfo from './Components/ProfessionalInfo.vue';

const props = defineProps({
   professional: Object
});
</script>
<template>
   <div style="background: linear-gradient(135deg,  rgba(224,213,229,1) 1%,rgba(154,1,192,1) 67%);"
      class=" h-screen flex justify-center items-center p-4 md:p-0">

      <div class="max-w-[500px]">
         <ProfessionalInfo :id="professional.id" />
      </div>

   </div>
</template>
